import React from "react";

const styles = {
  container: {
    fontFamily: "Arial, sans-serif",
    padding: "20px",
    lineHeight: "1.6",
    color: "#333",
  },
  header: {
    fontSize: "2rem",
    color: "#00000",
  },
  subHeader: {
    fontSize: "1.5rem",
    color: "#003366",
    marginTop: "20px",
  },
  paragraph: {
    marginBottom: "20px",
  },
  list: {
    marginLeft: "20px",
    marginBottom: "20px",
  },
  listItem: {
    marginBottom: "10px",
  },
  address: {
    marginTop: "20px",
  },
  link: {
    color: "#0056b3",
    textDecoration: "none",
  },
};

const Termofuse = () => {
  return (
    <div style={styles.container}>
      <h1 style={styles.header}>Terms of Use</h1>
      <p style={styles.paragraph}>
        <strong>Effective Date:</strong> 20 Jan 2025
      </p>
      <p style={styles.paragraph}>
        Welcome to Bizwit Insights ("the Service"), operated by Bizwit Research
        & Consulting LLP ("we," "our," or "us"). These Terms of Use ("Terms")
        govern your access to and use of the Service, including any content,
        functionality, and services offered through Bizwit Insights.
      </p>
      <p style={styles.paragraph}>
        By accessing or using Bizwit Insights, you agree to be bound by these
        Terms. If you do not agree with these Terms, you must not access or use
        the Service.
      </p>
      <hr />
      <h2 style={styles.subHeader}>1. Definitions</h2>
      <ul style={styles.list}>
        <li style={styles.listItem}>
          <strong>User:</strong> Any individual or entity who accesses or uses
          the Service.
        </li>
        <li style={styles.listItem}>
          <strong>Subscriber:</strong> A user who has purchased a subscription
          plan to access reports and other features.
        </li>
        <li style={styles.listItem}>
          <strong>Content:</strong> Includes but is not limited to text, images,
          reports, data, and other materials available through the Service.
        </li>
      </ul>
      <h2 style={styles.subHeader}>2. Eligibility</h2>
      <p style={styles.paragraph}>By using the Service, you represent and warrant that:</p>
      <ul style={styles.list}>
        <li style={styles.listItem}>You are at least 18 years old.</li>
        <li style={styles.listItem}>You have the legal capacity to enter into a binding contract.</li>
        <li style={styles.listItem}>
          Your use of the Service complies with all applicable laws and
          regulations.
        </li>
      </ul>
      <h2 style={styles.subHeader}>3. Account Registration</h2>
      <p style={styles.paragraph}>
        To access certain features of the Service, you must register for an
        account. You agree to:
      </p>
      <ul style={styles.list}>
        <li style={styles.listItem}>
          Provide accurate, current, and complete information during the
          registration process.
        </li>
        <li style={styles.listItem}>
          Maintain the confidentiality of your account and password.
        </li>
        <li style={styles.listItem}>
          Notify us immediately of any unauthorized use of your account or any
          other breach of security.
        </li>
      </ul>
      <h2 style={styles.subHeader}>4. Subscription Plans and Payments</h2>
      <h3 style={styles.subHeader}>4.1. Subscription Plans</h3>
      <p style={styles.paragraph}>
        We offer various subscription plans with different levels of access to
        reports and features. Details of these plans, including pricing and
        duration, are available on our website.
      </p>
      <h3 style={styles.subHeader}>4.2. Payment Terms</h3>
      <ul style={styles.list}>
        <li style={styles.listItem}>
          Subscription fees are billed in advance on a recurring basis (monthly
          or annually) as per the selected plan.
        </li>
        <li style={styles.listItem}>
          All payments are non-refundable, except as otherwise stated in these
          Terms or required by law.
        </li>
      </ul>
      <h3 style={styles.subHeader}>4.3. Changes to Subscription Plans</h3>
      <p style={styles.paragraph}>
        We reserve the right to modify or discontinue any subscription plan or
        feature at any time. We will provide reasonable notice of any material
        changes.
      </p>
      <h2 style={styles.subHeader}>5. User Conduct</h2>
      <p style={styles.paragraph}>
        You agree to use the Service only for lawful purposes and in a manner
        that does not infringe on the rights of others or restrict or inhibit
        their use of the Service. Prohibited activities include but are not
        limited to:
      </p>
      <ul style={styles.list}>
        <li style={styles.listItem}>Sharing your account or login credentials with others.</li>
        <li style={styles.listItem}>
          Downloading, copying, or redistributing any Content without our
          explicit permission.
        </li>
        <li style={styles.listItem}>
          Engaging in any activity that could harm the Service or impair others'
          use of it.
        </li>
      </ul>
      <h2 style={styles.subHeader}>6. Intellectual Property Rights</h2>
      <h3 style={styles.subHeader}>6.1. Ownership</h3>
      <p style={styles.paragraph}>
        All Content provided through the Service, including but not limited to
        reports, text, graphics, logos, and software, is the property of Bizwit
        Research & Consulting LLP or its licensors and is protected by
        intellectual property laws.
      </p>
      <h3 style={styles.subHeader}>6.2. License</h3>
      <p style={styles.paragraph}>
        Subject to your compliance with these Terms, we grant you a limited,
        non-exclusive, non-transferable, and revocable license to access and use
        the Service for personal or internal business purposes.
      </p>
      <h3 style={styles.subHeader}>6.3. Restrictions</h3>
      <p style={styles.paragraph}>You may not:</p>
      <ul style={styles.list}>
        <li style={styles.listItem}>
          Modify, reproduce, or create derivative works based on the Content.
        </li>
        <li style={styles.listItem}>
          Use the Content for commercial purposes other than as permitted under
          your subscription plan.
        </li>
        <li style={styles.listItem}>
          Decompile, reverse engineer, or disassemble any software or Content
          provided through the Service.
        </li>
      </ul>
      <h2 style={styles.subHeader}>7. Termination</h2>
      <h3 style={styles.subHeader}>7.1. By You</h3>
      <p style={styles.paragraph}>
        You may terminate your subscription and account at any time by
        contacting our support team or through your account settings.
      </p>
      <h3 style={styles.subHeader}>7.2. By Us</h3>
      <p style={styles.paragraph}>
        We reserve the right to suspend or terminate your access to the Service
        at any time, without notice, for conduct that we believe violates these
        Terms or is harmful to other users, us, or third parties.
      </p>
      <h3 style={styles.subHeader}>7.3. Effects of Termination</h3>
      <p style={styles.paragraph}>
        Upon termination, your right to use the Service will immediately cease.
        Any provisions of these Terms that by their nature should survive
        termination shall continue to apply, including but not limited to
        intellectual property rights, indemnities, and limitations of
        liability.
      </p>
      <h2 style={styles.subHeader}>8. Disclaimers and Limitation of Liability</h2>
      <h3 style={styles.subHeader}>8.1. No Warranties</h3>
      <p style={styles.paragraph}>
        The Service and all Content are provided on an "as is" and "as
        available" basis. We make no warranties, expressed or implied, regarding
        the Service, including but not limited to the accuracy, completeness, or
        reliability of any Content.
      </p>
      <h3 style={styles.subHeader}>8.2. Limitation of Liability</h3>
      <p style={styles.paragraph}>
        To the fullest extent permitted by law, we shall not be liable for any
        indirect, incidental, special, consequential, or punitive damages, or
        any loss of profits or revenues, whether incurred directly or
        indirectly, or any loss of data, use, goodwill, or other intangible
        losses, resulting from:
      </p>
      <ul style={styles.list}>
        <li style={styles.listItem}>Your use or inability to use the Service.</li>
        <li style={styles.listItem}>
          Unauthorized access, use, or alteration of your transmissions or
          Content.
        </li>
      </ul>
      <h2 style={styles.subHeader}>9. Indemnification</h2>
      <p style={styles.paragraph}>
        You agree to indemnify, defend, and hold harmless Bizwit Research &
        Consulting LLP, its affiliates, officers, directors, employees, and
        agents from and against any claims, liabilities, damages, losses, and
        expenses, including legal fees, arising out of or in any way connected
        with:
      </p>
      <ul style={styles.list}>
        <li style={styles.listItem}>Your access to or use of the Service.</li>
        <li style={styles.listItem}>Your violation of these Terms.</li>
        <li style={styles.listItem}>
          Your violation of any rights of another user or third party.
        </li>
      </ul>
      <h2 style={styles.subHeader}>10. Governing Law</h2>
      <p style={styles.paragraph}>
        These Terms shall be governed by and construed in accordance with the
        laws of MP, India, without regard to its conflict of law provisions.
      </p>
      <h2 style={styles.subHeader}>11. Dispute Resolution</h2>
      <h3 style={styles.subHeader}>11.1. Informal Resolution</h3>
      <p style={styles.paragraph}>
        We encourage you to contact us to resolve any issues before seeking
        legal recourse. Most concerns can be resolved quickly through our
        support team.
      </p>
      <h3 style={styles.subHeader}>11.2. Arbitration</h3>
      <p style={styles.paragraph}>
        Any disputes arising from or related to these Terms or the Service will
        be resolved by binding arbitration in accordance with the rules of
        [Arbitration Organization], except for disputes related to our
        intellectual property rights.
      </p>
      <h3 style={styles.subHeader}>11.3. Waiver of Class Actions</h3>
      <p style={styles.paragraph}>
        You agree to resolve any disputes with us on an individual basis and
        waive the right to participate in a class action lawsuit or class-wide
        arbitration.
      </p>
      <h2 style={styles.subHeader}>12. Changes to the Terms</h2>
      <p style={styles.paragraph}>
        We reserve the right to modify these Terms at any time. We will notify
        you of any changes by posting the updated Terms on this page and
        updating the "Effective Date." Your continued use of the Service after
        such modifications constitutes your acceptance of the updated Terms.
      </p>
      <h2 style={styles.subHeader}>13. Miscellaneous</h2>
      <h3 style={styles.subHeader}>13.1. Entire Agreement</h3>
      <p style={styles.paragraph}>
        These Terms constitute the entire agreement between you and Bizwit
        Research & Consulting LLP regarding the use of the Service and supersede
        any prior agreements.
      </p>
      <h3 style={styles.subHeader}>13.2. Waiver</h3>
      <p style={styles.paragraph}>
        Our failure to enforce any right or provision of these Terms will not be
        considered a waiver of those rights.
      </p>
      <h3 style={styles.subHeader}>13.3. Severability</h3>
      <p style={styles.paragraph}>
        If any provision of these Terms is found to be invalid or unenforceable,
        the remaining provisions will remain in full force and effect.
      </p>
      <h2 style={styles.subHeader}>14. Contact Us</h2>
      <p style={styles.paragraph}>
        If you have any questions about these Terms or the Service, please
        contact us at:
      </p>
      <address style={styles.address}>
        Bizwit Research & Consulting LLP
        <br />
        303, Atulya IT Park,
        <br />
        Indore (IN) 452001
        <br />
        Email:{" "}
        <a href="mailto:insights@bizwitresearch.com" style={styles.link}>
          insights@bizwitresearch.com
        </a>
        <br />
        Phone: +91 6267104147
      </address>
    </div>
  );
};

export default Termofuse;